import { AddOnDefinition, AddOns } from '..';

const definition: AddOnDefinition = {
	addOn: AddOns.MAINTENANCE_TIME,
	blockSlots: 1,
};

export default definition;
